function HideOnPrint(hide: boolean, styles: string) {
  return hide ? styles + ' print:hidden' : styles;
}

export default HideOnPrint;
